import { useEffect, useState } from "react";
import Helper from "../Helper";
import { MapObject } from "../models/MapObject";
import PlotAPI from "../plotAPI";

interface useMapObjectsProps {
    projects: any[];
    projectInfo: (projectId: string | number) => any | null;
}

const useMapObjects = (props: useMapObjectsProps) => {
    const [mapObjectsByProject, setMapObjectsByProject] = useState<{ unique_token: string; mapObjects: MapObject[] }[]>(
        []
    );

    useEffect(() => {
        refreshMapObjectsByProject();
    }, [props.projects]);

    const refreshMapObjectsByProject = () => {
        return Promise.all(
            props.projects.map((project) =>
                PlotAPI.getProjectMapObjects(
                    project.claimed_by_team_subdomain || "projects",
                    project.unique_token,
                    project.timezone
                ).then((mapObjects) => {
                    // Sort map objects by visibility rank
                    mapObjects = mapObjects.sort((a: MapObject, b: MapObject) => {
                        return Helper.mapObjectVisibilityRank(a) - Helper.mapObjectVisibilityRank(b);
                    });
                    return {
                        unique_token: project.unique_token,
                        mapObjects: mapObjects,
                    };
                })
            )
        ).then((objectsByProject) => {
            setMapObjectsByProject(objectsByProject);
        });
    };

    const mapObjectsForProject = (projectId: string | number): MapObject[] => {
        const projectToken = props.projectInfo(projectId)?.unique_token;

        return mapObjectsByProject.find((project) => project.unique_token === projectToken)?.mapObjects || [];
    };

    return {
        mapObjectsByProject,
        mapObjectsForProject,
        refreshMapObjectsByProject,
    };
};

export default useMapObjects;
